import {useNavigate} from 'react-router-dom'
import {Flex, Form, Image, message, Space, Switch, Tooltip, TreeSelect, Typography} from 'antd'
import {SActionBtn, SLowcodeList, SMessage, STableActions} from 'shj-components'
import {config, VisibilityList} from './config.tsx'
import TreeMenu from '@/pages/config/content/components/TreeMenu'
import {useDeepCompareEffect, useRequest, useSetState} from 'ahooks'
import {
    addContentCategory,
    appGrounding,
    cGrounding,
    deleteContentCategory,
    deleteContentInfo,
    queryBuildingInfoByEmployeeId,
    queryCategoryList,
    queryContentCategoryList,
    queryContentInfoList,
    updateContentCategory,
} from '@/services/content.ts'
import {tableApiFunc} from '@/utils/data.ts'
import {useRef} from 'react'
import {getUser} from 'shj-utils'
import {dateFormat} from "@/utils/date.ts";

const categoryType = 'article'

const defaultParams = {categoryType: categoryType, parentId: 0}

const statueEnum = [
    {label: '是', value: true},
    {label: '否', value: false},
]
const orderEnum = [
    {label: '创建时间', value: '1'},
    {label: '上架时间', value: '2'},
    {label: '分享数', value: '3'},
    {label: '浏览数', value: '4'},
]

function ArticleManage() {
    const navigate = useNavigate()

    const user = getUser();
    const tableRef = useRef<any>()
    const [form] = Form.useForm();

    const [state, setState]: any = useSetState({checkTree: []})

    const {runAsync: runSaveAsync} = useRequest(addContentCategory, {
        manual: true,
    })
    const {runAsync: runEditAsync} = useRequest(updateContentCategory, {
        manual: true,
    })
    const {runAsync: runDeleteAsync} = useRequest(deleteContentCategory, {
        manual: true,
    })
    const {data: categoryThreeList = []}: any = useRequest(queryCategoryList)
    const {
        data: categoryList = [],
        loading: treeLoading,
        runAsync: runCategoryList,
    }: any = useRequest(queryContentCategoryList, {
        defaultParams: [defaultParams],
    })

    useDeepCompareEffect(() => {
        tableRef.current.reload()
    }, state.checkTree)

    const onChangeStatus = (apiFunc, params, option) => {
        let str = `发布到${option.title}`
        if (!option.checked) {
            str = `下架${option.title}`
        }
        SMessage.confirm({
            title: option.checked ? '上架' : '下架',
            content: `确定${str}吗？`,
            onOk: async () => {
                try {
                    await apiFunc(params)
                    tableRef.current.reload()
                } catch (e) {
                    console.log(e)
                }
            },
        })
    }
    const onStoreByC = (option) => {
        SMessage.confirm({
            title: '上架C端',
            content: (
                <div>
                    <div style={{marginBottom: 10}}>需要配置C端分类</div>
                    <Form form={form} id='c-form'>
                        <Form.Item label="分类" name="buildingId" rules={[{required: true, message: '请选择楼盘'}]}
                                   extra='选择C端分类'>
                            <TreeSelect treeData={categoryThreeList || []}
                                        getPopupContainer={(): HTMLElement => document.getElementById('c-form')!}
                                        fieldNames={{label: 'name', value: 'id', children: 'childList'}}></TreeSelect>
                        </Form.Item>
                    </Form>
                </div>
            ),
            onOk: async () => {
                const res = await form.validateFields();
                try {
                    const params = {
                        "id": option.id,
                        "categoryIds": [res.buildingId],
                        "cgrounding": true
                    }
                    await cGrounding(params);
                    form.resetFields()
                    tableRef.current.reload()
                } catch (e) {
                    console.log(e)
                }
            },
            onCancel: () => {
                form.resetFields()
            }
        })
    }

    const onEditChange = ({type, values}: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            let apiFunc = runEditAsync
            if (type === 'add') {
                apiFunc = runSaveAsync
            } else if (type === 'delete') {
                apiFunc = runDeleteAsync
            }

            let params: any = {
                ...values,
                parentId: values?.parentId ?? 0,
                categoryName: values.name,
                categoryType: categoryType,
            }
            if (type === 'delete') {
                params = {
                    id: values.id,
                }
            }

            apiFunc(params)
                .then(res => {
                    runCategoryList(defaultParams)
                    resolve(res)
                })
                .catch(e => {
                    reject(e)
                })
        })
    }

    const onTreeMenuClick = (keys: Array<string>) => {
        setState({checkTree: keys})
    }

    const onAddOrEdit = (id: string = '') => {
        navigate(`/config/edit?type=${categoryType}&id=${id}`)
    }

    const runDelete = (id: string) => {
        deleteContentInfo({id}).then(() => {
            message.success('删除成功')
            tableRef.current.reload()
        })
    }
    const getStatusOptions = async () => {
        const estateList: any = await queryBuildingInfoByEmployeeId({})
        return Promise.resolve({
            statueEnum,
            orderEnum,
            estateList: (estateList || []).map(item => item?.buildingInfos || []).flat(),
            visibilityList: VisibilityList,
        })
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(queryContentInfoList, {
                data: {categoryType, categoryId: state.checkTree[0]},
                paginationInBody: true,
                fieldNames: {current: 'current'},
                transformSearch: (data) => {
                    const {createdDate, appGroundingDate, creleaseDate, ...rest} = data || {};
                    const [appGroundingTime, appGroundingTimeEnd] = appGroundingDate || [];
                    const [creleaseTime, creleaseTimeEnd] = creleaseDate || [];
                    const [createdTime, createdTimeEnd] = createdDate || [];
                    return {
                        ...rest,
                        appGroundingTime: appGroundingTime ? dateFormat(appGroundingTime, 'YYYY-MM-DD HH:mm:ss') : null,
                        appGroundingTimeEnd: appGroundingTimeEnd ? dateFormat(appGroundingTimeEnd, 'YYYY-MM-DD HH:mm:ss') : null,
                        creleaseTime: creleaseTime ? dateFormat(creleaseTime, 'YYYY-MM-DD HH:mm:ss') : null,
                        creleaseTimeEnd: creleaseTimeEnd ? dateFormat(creleaseTimeEnd, 'YYYY-MM-DD HH:mm:ss') : null,
                        createdTime: createdTime ? dateFormat(createdTime, 'YYYY-MM-DD HH:mm:ss') : null,
                        createdTimeEnd: createdTimeEnd ? dateFormat(createdTimeEnd, 'YYYY-MM-DD HH:mm:ss') : null,
                    };
                }
            }),
            getStatusOptions,
        },
        events: {
            onAdd: () => onAddOrEdit(),
        },
        customRender: {
            appRender(v: boolean, record: Record<string, any>) {
                return (
                    <Switch
                        disabled={record.createdBy !== user?.ucenterUserId}
                        checked={v}
                        onClick={checked =>
                            onChangeStatus(appGrounding, {id: record.id, appGrounding: checked}, {
                                title: 'App',
                                checked
                            })
                        }
                    />
                )
            },
            tagRender(v: any) {
                return (
                    <Flex>
                        <Tooltip title={(v || []).map(item => item?.tagName).join(';')}>
                            <Space>
                                {(v || []).slice(0, 2).map((item, index) => (
                                    <Typography style={{
                                        color: index % 2 == 0 ? 'rgba(245, 154, 35, 0.898039215686275)' : 'rgba(2, 167, 240, 0.898039215686275)',
                                        display: 'inline-block',
                                        cursor: 'pointer',
                                    }}>{item?.tagName}</Typography>
                                ))}
                            </Space>
                            {
                                (v || []).length > 2 && (
                                    <Typography.Text style={{color: 'rgba(0, 0, 0, 0.65)'}}>...</Typography.Text>
                                )
                            }
                        </Tooltip>
                    </Flex>
                )
            },
            titleRender(v: any, record: Record<string, any>) {
                return (
                    <Flex align='center'>
                        <Image preview={false} width={50} height={40} style={{objectFit: 'cover'}}
                               src={record.imageUrl}></Image>
                        <div style={{marginLeft: '10px', width: '100px'}}>
                            <Typography.Paragraph style={{marginBottom: 0}}
                                                  ellipsis={{rows: 2,}}>{v}</Typography.Paragraph>
                        </div>
                    </Flex>
                )
            },
            cRender(v: boolean, record: Record<string, any>) {
                return (
                    <Switch
                        checked={v}
                        disabled={record.createdBy !== user?.ucenterUserId}
                        onClick={checked => {
                            if (!checked) {
                                onChangeStatus(cGrounding, {id: record.id, cgrounding: checked}, {
                                    title: 'C端',
                                    checked
                                })
                            } else {
                                onStoreByC({id: record.id, cGrounding: checked});
                            }
                        }

                        }
                    />
                )
            },
            actionRender(_: null, record: Record<string, any>) {
                return (
                    !record.appGrounding && record.createdBy === user?.ucenterUserId && (
                        <STableActions>
                            <SActionBtn onClick={() => onAddOrEdit(record.id)}>编辑</SActionBtn>
                            <SActionBtn isDelete onClick={() => runDelete(record.id)}>
                                删除
                            </SActionBtn>
                        </STableActions>
                    )
                )
            },
        },
    }

    return (
        <div>
            <div style={{display: 'flex'}}>
                <div>
                    <TreeMenu
                        value={state.checkTree}
                        onClick={onTreeMenuClick}
                        treeData={categoryList}
                        loading={treeLoading}
                        fieldNames={{title: 'categoryName', key: 'id', children: 'childList'}}
                        onEditChange={onEditChange}
                    />
                </div>
                <SLowcodeList ref={tableRef} searchMode={'group'} config={config} {...extensions} />
            </div>
        </div>
    )
}

export default ArticleManage
